const contentKeys = {
  nothing: "nothing",
  contact: "contact",
  messageSent: "messageSent",
  user: "user",
  login: "login",
  form: "form",
};

export { contentKeys };
